export enum DebugType {
  WOB       = 'Wob',
  ACTION    = 'Action',
  UNDEFINED    = 'Undefined'
}